/// <reference types="vite/client" />
import * as Sentry from "@sentry/react";
import { StartClient } from "@tanstack/react-start/client";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { filterFrontendSentryEvent } from "./lib/error-classification";
import { frontendSentryPrivacyOptions } from "./lib/sentry-privacy";

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://a41d2064dae97772e99ffca030937f94@o4509364349239296.ingest.us.sentry.io/4509366335963137",
    ...frontendSentryPrivacyOptions,
    integrations: [
      Sentry.feedbackIntegration({
        ...frontendSentryPrivacyOptions.feedback,
      }),
    ],
    beforeSend: filterFrontendSentryEvent,
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>,
  );
});

reportWebVitals();
